// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"548":"bfed63c0","627":"2af8b419"}[chunkId] + ".chunk.css";
};